import {useLocation} from 'react-router-dom'
import {PageTitle} from 'layout/master-layout'

export default function FaqWrapper() {
 const location = useLocation()
 const url = location.state?.url

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
     }
     breadcrumbs={[
      {
       title: 'Home',
       path: '/home-page',
       isActive: false,
      },
      {
       title: 'FAQ',
       path: '/faq',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     FAQ
    </PageTitle>

    {/* FAQ Content */}
    <div className='w-full h-[85vh]'>
     {url && (
      <iframe
       src={url}
       title='FAQ'
       width='100%'
       height='100%'
       style={{border: 'none'}}
      />
     )}
    </div>
   </div>
  </div>
 )
}
